// Playback rates in proper toggling order
export const PLAYBACK_RATES: number[] = [
	1,
	1.3,
	1.5,
	1.7,
	2,
	0.5
];
